import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { motion, useScroll, useSpring } from "framer-motion";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";

import { Nav } from "@/components/wedding/Nav";
import { Hero } from "@/components/wedding/Hero";
import { SadhyaInvite } from "@/components/wedding/SadhyaInvite";
import { Reception } from "@/components/wedding/Reception";
import { Rsvp } from "@/components/wedding/Rsvp";
import { Footer } from "@/components/wedding/Footer";
import { MusicPlayer } from "@/components/wedding/MusicPlayer";
import { InvitationCover } from "@/components/wedding/InvitationCover";
import Admin from "@/pages/Admin";

function Home() {
  const lenisRef = useRef(null);
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    mass: 0.4,
  });

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    lenisRef.current = lenis;
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);

    if (window.location.hash) {
      const el = document.getElementById(window.location.hash.slice(1));
      if (el) setTimeout(() => lenis.scrollTo(el, { offset: -60, immediate: true }), 400);
    }

    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
    };
  }, []);

  const navigate = (target) => {
    const lenis = lenisRef.current;
    if (target === "top") {
      lenis ? lenis.scrollTo(0) : window.scrollTo({ top: 0 });
      return;
    }
    const el = document.getElementById(target);
    if (!el) return;
    lenis ? lenis.scrollTo(el, { offset: -60 }) : el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App grain relative bg-[var(--kasavu)]">
      <motion.div
        style={{ scaleX: progress }}
        className="fixed inset-x-0 top-0 z-[80] h-[3px] origin-left bg-gradient-to-r from-[var(--gold)] via-[var(--maroon)] to-[var(--green)]"
      />
      <InvitationCover onOpen={() => navigate("top")} />
      <Nav onNavigate={navigate} />
      <MusicPlayer />
      <main>
        <Hero onNavigate={navigate} />
        <SadhyaInvite />
        <Reception />
        <Rsvp />
      </main>
      <Footer />
    </div>
  );
}

// Slug for this event. White-label ready: add more <Route path="/:slug" ...> later.
const EVENT_SLUG = "chithra-weds-vishnu";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<Navigate to={`/${EVENT_SLUG}`} replace />} />
        <Route path={`/${EVENT_SLUG}`} element={<Home />} />
        <Route path={`/${EVENT_SLUG}/admin`} element={<Admin />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Navigate to={`/${EVENT_SLUG}`} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
